import React, { useState, useEffect, useMemo, useCallback } from 'react';

import {
  makeStyles,
  Container,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { injectIntl } from 'react-intl';
import CustomPaginationActionsTable from 'app/components/TableList/TableList';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchRequests,
  clearRequestDetails,
} from 'app/store/slices/requests';
import { useHistory } from 'react-router-dom';
import { URLS } from 'app/config/urls';

import helpers from 'app/utils/helpers';
import moment from 'moment';
import notification from 'app/config/notification';
import { errorHandler } from 'app/utils/errorHandler';
import { STATUS_COLORS } from 'app/config/status';
import { USER_SECTORS } from 'app/utils/constants';

import { searchCompanyNameAndDocumentByCdUsuario } from 'app/store/slices/company';
import { fecthLicenseChangeTypes } from 'app/store/slices/license';
import { SERVICES_GROUPS } from 'app/config/services';

import styles from './styles';
const useStyles = makeStyles(styles);

function Requests(props) {
  const classes = useStyles();
  const requests = useSelector(state => state.requests.requests);
  const licenseChangeTypes = useSelector(state => state.license.licenseChangeTypes);

  const history = useHistory();
  const dispatch = useDispatch();

  const { filters, setFilters, loading, setLoading } = props;
  const user = useSelector(state => state.auth.user);

  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(filters.page || 0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);

  const [initialDate, setInitialDate] = useState(null);
  const [finalDate, setFinalDate] = useState(null);
  const [orderBy, setOrderBy] = useState(filters.campoOrdenacao || 'dtCadastro');
  const [orderDirection, setOrderDirection] = useState(filters.direcaoOrdenacao || 'desc');

  const listType = useMemo(() => {
    if (user?.setores) {
      const sectors = user.setores.filter(s => {
        return s.cdOrgaoSetor !== USER_SECTORS.INT && s.cdOrgaoSetor !== USER_SECTORS.EXT;
      });
      if (sectors.length > 0) return sectors[0].cdOrgaoSetor;
    }
    return USER_SECTORS.DPE_DPSE;
  }, [user]);

  const handleChangeFilter = (key, value) => {
    const temp = { ...filters };
    temp[key] = value;
    setFilters(temp);
  };

  const onChangePage = (event, page) => {
    setPage(page);
    const temp = { ...filters };
    temp['page'] = page;
    setFilters(temp);
  };

  const onChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onBlurSearch = event => {
    handleChangeFilter('txtBusca', event.target.value);
    setPage(0);
  };

  const onChangeSearch = event => {};

  const prepareData = useCallback(
    async content => {
      let document = content.docUsuario || '';
      let name = content.nmUsuario || '';
      let subtitle = null;

      if (content.jsonSolicitacao) {
        try {
          const jsonSolicitacao = JSON.parse(content.jsonSolicitacao);
          document = jsonSolicitacao.cdTipoPessoaFisica
            ? jsonSolicitacao.deCpf || content.docUsuario || ''
            : jsonSolicitacao.deCnpjMatriz ||
            jsonSolicitacao.deCpfCnpj ||
            content.docUsuario || '';
          name = jsonSolicitacao.cdTipoPessoaFisica
            ? jsonSolicitacao.nmCompleto || content.nmUsuario || ''
            : jsonSolicitacao.deRazaoSocial ||
              jsonSolicitacao.nmCompleto ||
              jsonSolicitacao.nmUsuario ||
              content.nmUsuario || '';

          if ((document === '' || name === '') && content.cdSolicitacao) {
            const companyInfo = await searchCompanyNameAndDocumentByCdUsuario(content.cdUsuarioSolicitacao);
            name = companyInfo.name;
            document = companyInfo.document;
          }
          if (
            SERVICES_GROUPS.LICENSE.includes(content.cdServico) &&
            jsonSolicitacao.cdTipoAlteracaoLicenca
          ) {
            const found = licenseChangeTypes.filter(
              lt => lt.cdTipoAlteracaoLicenca === Number(jsonSolicitacao.cdTipoAlteracaoLicenca)
            );
            if (found && found[0]) {
              subtitle = found[0].deTipoAlteracaoLicenca;
            }
          }
        } catch (error) {
          errorHandler(error.response?.status, error.response?.data?.message);
        }

      }

      const situacao = content.deSituacao || content.situacao?.deSituacao;
      const cdSituacao = content.cdSituacao || content.situacao?.cdSituacao;

      const servico = content.nmServico || content.servico?.nmServico;

      return {
        originalData: content,
        dtCadastro: (
          <>
            <div>{helpers.formatarData(content.dtCadastro, true)}</div>
            {servico && (
              <div>
                <strong>{servico}</strong>
                {subtitle && (
                  <>
                    <br />
                    {subtitle}
                  </>
                )}
              </div>
            )}
          </>
        ),
        cdEmpresa: (
          <>
            {document !== '' && <div>{helpers.formatarDocumento(document)}</div>}
            {name !== '' && (
              <div>
                <strong>{name}</strong>
              </div>
            )}
          </>
        ),
        nuSolicitacao: (
          <>
            {content.nuSolicitacaoFmt && <div>{content.nuSolicitacaoFmt}</div>}
            {content.nuProcesso && <div>{content.nuProcesso}</div>}
          </>
        ),
        deSituacao: (
          <>
            {(content.dtVencimentoPendencia || content.dtVencimento) && (
              <div>
                <strong>{helpers.formatarData(content.dtVencimento || content.dtVencimentoPendencia, true)}</strong>
              </div>
            )}
            {situacao && (
              <div style={{ color: `${STATUS_COLORS[cdSituacao]?.color}` }}>
                <strong>{situacao}</strong>
              </div>
            )}
          </>
        ),
      };
    },
    [licenseChangeTypes]
  );

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const promises = [];
        if(licenseChangeTypes.length === 0){
          promises.push(dispatch(fecthLicenseChangeTypes()));
        }
        const search = { ...filters, page: page, size: pageSize, otimizada: true };
        promises.push(dispatch(fetchRequests(search, '')));
        await Promise.all(promises);
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
        setLoading(false);
      }
      setLoading(false);
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters, page, pageSize]);

  useEffect(() => {
    dispatch(clearRequestDetails());
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      const rowsTemp = [];
      if (requests.content) {
        setLoading(true);
        for (const cont of requests.content) {
          const rowsPrepared = await prepareData(cont);
          rowsTemp.push(rowsPrepared);
        }
        setLoading(false);
      }
      setRows(rowsTemp);
      setPagination(requests);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requests]);

  const handleClickRow = (e, row) => {
    // dispatch(updateRequestDetails(row.originalData));
    history.push(`${URLS.INTERNAL_REQUEST}${row.originalData.cdSolicitacao}`, { filters });
  };

  const handleInitialDate = date => {
    if (helpers.validateDate(date)) {
      handleChangeFilter('dtPeriodoInicialCadastro', moment.utc(date).format('YYYY-MM-DD'));
      setInitialDate(date);
    }
  };

  const handleFinalDate = date => {
    if (helpers.validateDate(date)) {
      let dateError = false;
      if (filters.dtPeriodoInicialCadastro && filters.dtPeriodoInicialCadastro !== '') {
        let isAfter = moment.utc(date).isSameOrAfter(filters.dtPeriodoInicialCadastro);
        if (!isAfter) {
          dateError = true;
        }
      }
      if (dateError) {
        notification(
          'Verifique as datas informadas. Elas precisam ser válidas e a data final maior ou igual a data incial.',
          {
            toastId: 'DATE_PROBLEM',
            type: 'error',
          }
        );
        return;
      }
      handleChangeFilter('dtPeriodoFinalCadastro', moment.utc(date).format('YYYY-MM-DD'));
      setFinalDate(date);
    }
  };

  const handleOrderBy = e => {
    const value = e.target.value;
    setOrderBy(value);
    const temp = { ...filters };
    temp['campoOrdenacao'] = value;
    setFilters(temp);
    setPage(0);
  };

  const handleOrderDirection = e => {
    const value = e.target.value;
    setOrderDirection(value);
    const temp = { ...filters };
    temp['direcaoOrdenacao'] = value;
    setFilters(temp);
    setPage(0);
  };

  const columns = useMemo(() => {
    let fields = [
      {
        title: 'Data solicitada / Solicitação',
        field: 'dtCadastro',
        align: 'left',
      },
      { title: 'Identificação', field: 'cdEmpresa', align: 'left' },
      { title: 'nº solicitação / processo', field: 'nuSolicitacao', align: 'left' },
      {
        title: 'Data venc. pendências / Situação',
        field: 'deSituacao',
        align: 'left',
      },
    ];

    if (listType === USER_SECTORS.DQS_DFIS_COVIT) {
      //VEHICLES
      fields = [
        {
          title: 'Data solicitada / Solicitação',
          field: 'dtCadastro',
          align: 'left',
        },
        {
          title: 'Identificação',
          field: 'cdEmpresa',
          align: 'left',
          style: {
            minWidth: '150px',
          },
        },
        { title: 'nº solicitação / processo', field: 'nuSolicitacao', align: 'left' },
        { title: 'Placa / Renavam', field: 'dePlaca', align: 'left' },
        {
          title: 'Data venc. pendências / Situação',
          field: 'deSituacao',
          align: 'left',
        },
      ];
    }

    return fields;
  }, [listType]);

  return (
    <>
      <Container className={classes.container}>
        <Grid container spacing={3} className={classes.containerOrder}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Ordenar por:</InputLabel>
              <Select value={orderBy} onChange={handleOrderBy}>
                <MenuItem value="dtCadastro">Data da solicitação</MenuItem>
                <MenuItem value="nmServico">Solicitação</MenuItem>
                <MenuItem value="deRazaoSocial">Razão social / Nome</MenuItem>
                <MenuItem value="nuSolicitacao">Número da solicitação</MenuItem>
                <MenuItem value="nuProcesso">Número do processo</MenuItem>
                <MenuItem value="dtVencimentoRevisao">Data de vencimento pendências</MenuItem>
                <MenuItem value="deSituacao">Situação</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Direção:</InputLabel>
              <Select value={orderDirection} onChange={handleOrderDirection}>
                <MenuItem value="asc">Ascendente</MenuItem>
                <MenuItem value="desc">Descendente</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <CustomPaginationActionsTable
          loading={loading}
          columns={columns}
          rows={rows}
          hideFilterOrder={true}
          hideItemOrder={true}
          placeholderSearch="Busca"
          pagination={pagination}
          initialDate={initialDate}
          finalDate={finalDate}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onBlurSearch={onBlurSearch}
          onClickOrder={() => {}}
          onChangeSearch={onChangeSearch}
          onClickRow={handleClickRow}
          onChangeInitialDate={handleInitialDate}
          onChangeFinalDate={handleFinalDate}
        />
      </Container>
    </>
  );
}

export default injectIntl(Requests);
